import { CommunityType, EstimateType, LotType } from "src/generated/graphqlTypes";
import { EstimatePageQuery } from "src/routes/projects/estimates/EstimatePage.generated";
export function createContractDisabledReason(estimate: EstimatePageQuery["projectEstimate"]): string | undefined {
  const isChangeOrderEstimate = estimate.changeEvent?.id !== undefined;
  const { projectStage } = estimate;
  const { lotType, communityType } = projectStage.project;
  const isBoolInfill = lotType.code === LotType.Bool && communityType?.code === CommunityType.Infill;
  return isBoolInfill && !isChangeOrderEstimate
    ? "Contract creation is handled automatically when we close on the lot"
    : estimate.type.code === EstimateType.Preliminary
      ? "Only final estimates can create contracts"
      : projectStage.hasSignedContract && !isChangeOrderEstimate
        ? "Stage already has a prime contract"
        : undefined;
}
